import React, { Component } from 'react';
import { Modal, Input, Select, DatePicker, Button, Icon, message } from 'antd';
import AddCooperationUnit from './AddCooperationUnit';
import AddTeamLeaderUnit from './AddTeamLeaderUnit';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SearchInput from './SearchInput';
import ContentList from '../../basicElement/ContentList';
import moment from 'moment';
import './style.less';

const { Option } = Select;
const { TextArea } = Input;
const dateFormat = "YYYY-MM-DD";
let isCRC = false;

class HeredityView extends Component {
    state = {
        isEdit: false,
        visible: false,
        confirmLoading: false,
    }
    
    show = (record) => {
        const { curRole } = sessionStorage;
        isCRC = curRole === 'CRC';
        const setting = {};
        if (isCRC) {
            setting.heredityDeclareType = 'REGISTER_LISTED_OPTIMIZE';
            setting.registerListedOptimizeDeclareType = 'JOIN_DEPARTMENT_RECORD';
        }
        const { heredityHospitals } = record || {};
        let teamLeaderList = [];
        let cooperationList = [];
        (heredityHospitals || []).forEach(i => {
            const { heredityHospitalType, hospitalId, groupHospitalName, isReportUnit, constitutionName, cooperationType, cooperationOtherRemark } = i;
            if (heredityHospitalType === 'GROUP_DEPARTMENT') {
                teamLeaderList.push({
                    hospitalId,
                    hospitalName: groupHospitalName,
                    isReportUnit,
                });
            } else if (heredityHospitalType === 'COOPERATION_DEPARTMENT') {
                let cooperationTypeValue;
                if (cooperationType === 'CRO') {
                    cooperationTypeValue = 'CRO';
                } else if (cooperationType === 'SPONSOR') {
                    cooperationTypeValue = '申办方';
                } else if (cooperationType === 'FQT') {
                    cooperationTypeValue = '第三方实验室';
                } else if (cooperationType === 'OTHER') {
                    cooperationTypeValue = '其他';
                }
                cooperationList.push({
                    constitutionName,
                    cooperationType,
                    cooperationTypeValue,
                    cooperationOtherRemark,
                });
            }
        });

        this.setState({
            isEdit: !!record,
            visible: true,
            joinList: [],
            showJoinList: [],
            joinValue: '',
            params: {
                heredityDeclareType: 'REGISTER_LISTED_OPTIMIZE',
                ...(record || {}),
                ...setting,
                teamLeaderList,
                cooperationList,
            },
        }, () => {
            record && this.getHeredityDeclareList();
        });
    };

    close = () => {
        this.setState({ visible: false });
    };

    getHeredityDeclareList = () => {
        const  { isEdit, params } = this.state;
        const  { orders, heredityDeclareType, registerListedOptimizeDeclareType } = params;
        const data = {};
        if (heredityDeclareType == 'PERSON_HEREDITY_RESEARCH') {
            data.progressType = 'OTHERS';
        } else if (heredityDeclareType == 'REGISTER_LISTED_OPTIMIZE') {
            if (!registerListedOptimizeDeclareType) {
                message.warning('请选择注册上市优化申报类型');
                return;
            } else if (registerListedOptimizeDeclareType == 'FIRST_DECLARE' || registerListedOptimizeDeclareType == 'SUPPLEMENT_DECLARE') {
                data.progressType = 'OTHERS';
            } else if (registerListedOptimizeDeclareType == 'JOIN_DEPARTMENT_RECORD') {
                data.progressType = 'RECORD';
            }
        }
        if (isEdit) {
            data.orders = orders || '';
        }
        const options = {
            method: 'POST',
            url: API_URL.invStartUp.queryHeredityDeclareProgressList,
            data,
            dataType: 'json',
            doneResult: res => {
                this.setState({ heredityDeclareList: res.heredityDeclareProgress});
            },
        };
        $.sendRequest(options);
    }

    confirm = () => {
        let url;
        const { isEdit, params, showJoinList = [] } = this.state;
        const  {
            heredityDeclareType,
            registerListedOptimizeDeclareType,
            teamLeaderList,
            cooperationList,
            declareProgressId,
            approvalNumber,
            approvalValidityDate = null,
            heredityReplyDate = null,
            mailRecordDate = null,
            weatherShowDeclaration,
            weatherSeal,
            fileLocation,
        } = params;

        if (!isEdit) {
            if (heredityDeclareType == 'REGISTER_LISTED_OPTIMIZE') {
                if (!registerListedOptimizeDeclareType) {
                    message.error('请选择注册上市优化申报类型');
                    return;
                }
                if (registerListedOptimizeDeclareType == 'FIRST_DECLARE' || registerListedOptimizeDeclareType == 'SUPPLEMENT_DECLARE') {
                    if (!(teamLeaderList || []).length) {
                        message.error('请添加医疗机构(组长单位)');
                        return;
                    }
                    if (!(cooperationList || []).length) {
                        message.error('请添加合作单位(单位类别)');
                        return;
                    }
                    if (!weatherShowDeclaration) {
                        message.error('请选择津石是否出现在申报文件上');
                        return;
                    }
                    if (weatherShowDeclaration === 'YES') {
                        if (!fileLocation) {
                            message.error('请选择津石出现在文件具体位置');
                            return;
                        }
                        if (!weatherSeal) {
                            message.error('请选择津石是否盖章');
                            return;
                        }
                    }
                    if (showJoinList.length > 0) {
                        showJoinList.map((item, index) => {
                            params[`joinHeredityHospitalIds[${index}]`] = item.hospitalId;
                        })
                    }

                    if (!declareProgressId) {
                        message.error('请选择申报进展');
                        return;
                    } else if (declareProgressId == '8') {
                        if (!approvalNumber) {
                            message.error('请输入批文号码');
                            return;
                        } else if (!approvalValidityDate) {
                            message.error('请选择批文有效期');
                            return;
                        }
                    } else {
                        params.approvalNumber = null;
                        params.approvalValidityDate = null;
                    }
                    params.mailRecordDate = null;
                    params.heredityReplyDate = null;
                } else if (registerListedOptimizeDeclareType == 'JOIN_DEPARTMENT_RECORD') {
                    if (showJoinList.length <= 0) {
                        message.error('请添加参与单位');
                        return;
                    } else {
                        showJoinList.map((item, index) => {
                            params[`joinHeredityHospitalIds[${index}]`] = item.hospitalId;
                        });
                    }

                    if (!declareProgressId) {
                        message.error('请选择申报进展');
                        return;
                    } else if (declareProgressId == '11') {
                        params.heredityReplyDate = null;
                    } else if (declareProgressId == '12'){
                        if (!heredityReplyDate) {
                            message.error('请选择遗传办回复日期');
                            return;
                        }
                    } else {
                        params.mailRecordDate = null;
                        params.heredityReplyDate = null;
                    }
                    params.approvalNumber = null;
                    params.approvalValidityDate = null;
                }
            } else if (heredityDeclareType == 'PERSON_HEREDITY_RESEARCH') {
                if (showJoinList.length <= 0) {
                    message.error('请添加医疗机构(参与单位)');
                    return;
                } else {
                    showJoinList.map((item, index) => {
                        params[`joinHeredityHospitalIds[${index}]`] = item.hospitalId;
                    })
                }

                if (!declareProgressId) {
                    message.error('请选择申报进展');
                    return;
                } else if (declareProgressId == '8') {
                    if (!approvalNumber) {
                        message.error('请输入批文号码');
                        return;
                    } else if (!approvalValidityDate) {
                        message.error('请选择批文有效期');
                        return;
                    }
                } else {
                    params.approvalNumber = null;
                    params.approvalValidityDate = null;
                }
                params.registerListedOptimizeDeclareType = null ;
                params.mailRecordDate = null;
                params.heredityReplyDate = null;
            }
            url = API_URL.invStartUp.saveHeredity;
        } else if (isEdit) {
            if (heredityDeclareType == 'REGISTER_LISTED_OPTIMIZE') {
                if (registerListedOptimizeDeclareType == 'FIRST_DECLARE' || registerListedOptimizeDeclareType == 'SUPPLEMENT_DECLARE') {
                    if (!(cooperationList || []).length) {
                        message.error('请添加合作单位(单位类别)');
                        return;
                    }
                    if (!weatherShowDeclaration) {
                        message.error('请选择津石是否出现在申报文件上');
                        return;
                    }
                    if (weatherShowDeclaration === 'YES') {
                        if (!fileLocation) {
                            message.error('请选择津石出现在文件具体位置');
                            return;
                        }
                        if (!weatherSeal) {
                            message.error('请选择津石是否盖章');
                            return;
                        }
                    }
                    if (!declareProgressId) {
                        message.error('请选择申报进展');
                        return;
                    } else if (declareProgressId == '8') {
                        if (!approvalNumber) {
                            message.error('请输入批文号码');
                            return;
                        } else if (approvalValidityDate == null) {
                            message.error('请选择批文有效期');
                            return;
                        }
                    } else {
                        params.approvalNumber = null;
                        params.approvalValidityDate = null;
                    }
                } else if (registerListedOptimizeDeclareType == 'JOIN_DEPARTMENT_RECORD') {
                    if (!declareProgressId) {
                        message.error('请选择申报进展');
                        return;
                    } else if (declareProgressId == '11') {
                        params.heredityReplyDate = null;
                    } else if (declareProgressId == '12'){
                        if (!heredityReplyDate) {
                            message.error('请选择遗传办回复日期');
                            return;
                        }
                    } else {
                        params.mailRecordDate = null;
                        params.heredityReplyDate = null;
                    }
                }
            } else if (heredityDeclareType == 'PERSON_HEREDITY_RESEARCH') {
                if (!declareProgressId) {
                    message.error('请选择申报进展');
                    return;
                } else if (declareProgressId == '8') {
                    if (approvalNumber == '') {
                        message.error('请输入批文号码');
                        return;
                    } else if (!approvalValidityDate) {
                        message.error('请选择批文有效期');
                        return;
                    }
                } else {
                    params.approvalNumber = null;
                    params.approvalValidityDate = null;
                }
            }
            if (approvalValidityDate == '-') {
                params.approvalValidityDate = null;
            }
            if (mailRecordDate == '-') {
                params.mailRecordDate = null;
            }
             if (heredityReplyDate == '-') {
                params.heredityReplyDate = null;
            }
            params.joinHeredityHospitalName = null;
            params.groupLeaderHeredityHospitalName = null;
            url = API_URL.invStartUp.updateHeredity;
        }

        let idx = 0;
        (teamLeaderList || []).forEach(item => {
            const { hospitalId, isReportUnit } = item;
            params[`heredityHospitals[${idx}].heredityHospitalType`] = 'GROUP_DEPARTMENT';
            params[`heredityHospitals[${idx}].hospitalId`] = hospitalId;
            params[`heredityHospitals[${idx}].isReportUnit`] = isReportUnit;
            idx++;
        });
        (cooperationList || []).forEach(item => {
            const { constitutionName, cooperationType, cooperationOtherRemark } = item;
            params[`heredityHospitals[${idx}].heredityHospitalType`] = 'COOPERATION_DEPARTMENT';
            params[`heredityHospitals[${idx}].constitutionName`] = constitutionName;
            params[`heredityHospitals[${idx}].hospitalId`] = 0;
            params[`heredityHospitals[${idx}].cooperationType`] = cooperationType;
            params[`heredityHospitals[${idx}].cooperationOtherRemark`] = cooperationOtherRemark;
            idx++;
        });
        delete params.teamLeaderList;
        delete params.cooperationList;
        delete params.heredityHospitals;

        this.setState({ confirmLoading: true });
        const options = {
            method: 'POST',
            url,
            data: { ...params },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.success);
                    this.setState({ visible: false });
                    this.props.reload();
                } else {
                    message.error(res.error);
                }
                this.setState({ confirmLoading: false });
            }),
            errorResult: (res => {
                this.setState({ confirmLoading: false });
            }),
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        switch (key) {
            case 'heredityDeclareType':
                params[key] = value;
                params.declareProgressId = undefined;
                this.setState({ params }, () => {
                    this.handleChange(undefined, 'registerListedOptimizeDeclareType');
                });
                break;
            case 'registerListedOptimizeDeclareType': {
                params[key] = value;
                params.declareProgressId = undefined;
                params.teamLeaderList = [];
                params.cooperationList = [];
                params.weatherShowDeclaration = (value === 'FIRST_DECLARE' || value === 'SUPPLEMENT_DECLARE') ? 'NO' : undefined;
                params.weatherSeal = undefined;
                params.fileLocation = undefined;
                this.setState({ params });
                break;
            }
            case 'cooperationType':
                params[key] = value;
                params.cooperationOtherRemark = '';
                this.setState({ params });
                break;
            case 'weatherShowDeclaration':
                params[key] = value;
                params.weatherSeal = value === 'YES' ? 'NO' : undefined;
                params.fileLocation = undefined;
                this.setState({ params });
                break;
            default:
                params[key] = value;
                this.setState({ params });
                break;
        }
    }

    //参与单位
    saveJoinData = (data) => {
        this.setState({ joinList: data });
    }

    saveJoinValue = (value) => {
        this.setState({ joinValue: value });
    }

    parseJoinData = () => {
        const { joinList = [] } = this.state;
        const options = joinList.map(d => <Option key={d.hospitalId} value={d.hospitalName}>{d.hospitalName}</Option>);
        return options;
    }

    handleAddUnit = (type) => {
        const { params: { teamLeaderList, cooperationList } } = this.state;
        if (type === 'teamLeader') {
            this.teamLeaderUnitRef.show(teamLeaderList);
        } else {
            this.cooperationUnitRef.show(cooperationList);
        }
    }

    handleAdd = () => {
        const { joinList = [], showJoinList = [], joinValue } = this.state;
        let value;
        if (!joinValue) {
            message.warning('请添加医疗机构(参与单位)');
            return;
        } else {
            value = joinList.filter(item => item.hospitalName == joinValue);
            if (value.length > 0) {
                const hasSameValue = showJoinList.some(item => item.hospitalId == value[0].hospitalId);
                hasSameValue ? message.warning('医疗机构(参与单位)不能重复添加') : showJoinList.push(value[0]);
            }
        }
        this.setState({
            showJoinList,
            joinValue: undefined,
        });
    }

    handleRemove = (key, index) => {
        const { params, showJoinList } = this.state;
        const { teamLeaderList, cooperationList } = params;
        if (key == 'teamLeader') {
            teamLeaderList.splice(index, 1);
        } else if (key == 'cooperation') {
            cooperationList.splice(index, 1);
        } else {
            showJoinList.splice(index, 1);
        }
        this.setState({ params, showJoinList });
    }

    getContentList = (key) => {
        const { isEdit, params: { teamLeaderList, cooperationList } = {}, showJoinList = [] } = this.state;
        let data;
        let render;
        let deteable;
        switch(key) {
            case 'teamLeader':
                deteable = !isEdit;
                data = teamLeaderList;
                render = item => {
                    const { hospitalName, isReportUnit } = item;
                    return `${hospitalName}${isReportUnit == 1 ? '(申报单位)' : ''}`;
                };
                break;
            case 'cooperation':
                deteable = true;
                data = cooperationList;
                render = item => {
                    const { constitutionName, cooperationTypeValue, cooperationOtherRemark } = item;
                    return `${constitutionName}(${cooperationTypeValue}${cooperationOtherRemark ? `-${cooperationOtherRemark}` : ''})`;
                };
                break;
            case 'join':
                deteable = true;
                data = showJoinList;
                render = item => item.hospitalName;
                break;
        }
        return (
            <ContentList
                className="update"
                data={data}
                deteable={deteable}
                onRemove={(index) => this.handleRemove(key, index)}
                render={render}
            />
        );
    }

    getHeredityRecord = () => {
        const {
            isEdit,
            params = {},
            joinList = [],
            heredityDeclareList = [],
            joinValue,
        } = this.state;
        const {
            heredityDeclareType,
            heredityDeclareTypeName,
            registerListedOptimizeDeclareType,
            registerListedOptimizeDeclareTypeName,
            joinHeredityHospitalName,
            declareProgressId,
            approvalNumber,
            approvalValidityDate,
            mailRecordDate,
            heredityReplyDate,
            remark,
            weatherShowDeclaration,
            weatherSeal,
            fileLocation,
        } = params;
        const heredityDeclareOptions = heredityDeclareList.map(item => <Option key={item.heredityDeclareProgressId} value={item.heredityDeclareProgressId}>{item.declareProgressName}</Option>);
        const showApprovalValidityDate = approvalValidityDate ? moment(approvalValidityDate) : null;
        const showMailRecordDate = mailRecordDate ? moment(mailRecordDate) : null;
        const showHeredityReplyDate = heredityReplyDate ? moment(heredityReplyDate) : null;
        const asterisk = <span style={{color: 'red'}}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">
                        { !isEdit && asterisk }
                        遗传办申报类型:
                    </div>
                    <div className="item-right">
                        {
                            !isEdit
                            ?
                                <Select
                                    style={{width: 200}}
                                    value={heredityDeclareType}
                                    disabled={isCRC}
                                    onChange={value => this.handleChange(value, 'heredityDeclareType')}
                                >
                                    <Option value="REGISTER_LISTED_OPTIMIZE">注册上市优化申报</Option>
                                    <Option value="PERSON_HEREDITY_RESEARCH">涉及人类遗传资源相关研究申报</Option>
                                </Select>
                            :
                                heredityDeclareTypeName
                        }
                    </div>
                </li>
                {
                    heredityDeclareType == 'REGISTER_LISTED_OPTIMIZE' &&
                    <div>
                        <li className="modal-item">
                            <div className="item-left">
                                { !isEdit && asterisk }
                                注册上市优化申报类型:
                            </div>
                            <div className="item-right">
                                {
                                    !isEdit
                                    ?
                                        <Select
                                            placeholder="请选择"
                                            style={{width: 200}}
                                            disabled={isCRC}
                                            value={registerListedOptimizeDeclareType}
                                            onChange={value => this.handleChange(value, 'registerListedOptimizeDeclareType')}
                                            allowClear={true}
                                        >
                                            <Option value="FIRST_DECLARE">首次申报</Option>
                                            <Option value="SUPPLEMENT_DECLARE">补充申报</Option>
                                            <Option value="JOIN_DEPARTMENT_RECORD">参与单位备案</Option>
                                        </Select>
                                    :
                                        registerListedOptimizeDeclareTypeName
                                }
                            </div>
                        </li>
                        {
                            (registerListedOptimizeDeclareType == 'FIRST_DECLARE' || registerListedOptimizeDeclareType == 'SUPPLEMENT_DECLARE') &&
                            <li className="modal-item">
                                <div className="item-left">
                                    { !isEdit && asterisk }
                                    医疗机构(组长单位):
                                </div>
                                <div className="item-right">
                                    { !isEdit && <Button type="primary" style={{ marginBottom: 10 }} onClick={() => this.handleAddUnit('teamLeader')}>添加</Button> }
                                    {this.getContentList('teamLeader')}
                                </div>
                            </li>
                        }
                    </div>
                }
                {
                    (registerListedOptimizeDeclareType == 'FIRST_DECLARE' || registerListedOptimizeDeclareType == 'SUPPLEMENT_DECLARE') &&
                    <div>
                        <li className="modal-item">
                            <div className="item-left">{asterisk}合作单位(单位类别):</div>
                            <div className="item-right">
                                <Button type="primary" style={{ marginBottom: 10 }} onClick={() => this.handleAddUnit('cooperation')}>添加</Button>
                                {this.getContentList('cooperation')}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">{asterisk}津石是否出现在申报文件上:</div>
                            <div className="item-right">
                                <Select
                                    placeholder="请选择"
                                    style={{width: 200}}
                                    value={weatherShowDeclaration || undefined}
                                    onChange={value => this.handleChange(value, 'weatherShowDeclaration')}
                                    allowClear={true}
                                >
                                    <Option value='YES'>是</Option>
                                    <Option value='NO'>否</Option>
                                </Select>
                            </div>
                        </li>
                        {
                            weatherShowDeclaration === 'YES' &&
                            <li className="modal-item">
                                <div className="item-left">{asterisk}津石出现在文件具体位置:</div>
                                <div className="item-right">
                                    <Select
                                        placeholder="请选择"
                                        style={{width: 200}}
                                        value={fileLocation || undefined}
                                        onChange={value => this.handleChange(value, 'fileLocation')}
                                        allowClear={true}
                                    >
                                        <Option value='CONSTITUTION'>合作单位</Option>
                                        <Option value='OTHER'>其他</Option>
                                    </Select>
                                </div>
                            </li>
                        }
                        {
                            weatherShowDeclaration === 'YES' &&
                            <li className="modal-item">
                                <div className="item-left">{asterisk}津石是否盖章:</div>
                                <div className="item-right">
                                    <Select
                                        placeholder="请选择"
                                        style={{width: 200}}
                                        value={weatherSeal || undefined}
                                        onChange={value => this.handleChange(value, 'weatherSeal')}
                                        allowClear={true}
                                    >
                                        <Option value='YES'>是</Option>
                                        <Option value='NO'>否</Option>
                                    </Select>
                                </div>
                            </li>
                        }
                    </div>
                }
                <li className="modal-item">
                    {
                        (heredityDeclareType == 'PERSON_HEREDITY_RESEARCH') ||
                        (heredityDeclareType == 'REGISTER_LISTED_OPTIMIZE' && registerListedOptimizeDeclareType == 'JOIN_DEPARTMENT_RECORD')
                        ?
                            <div className="item-left">
                                { !isEdit && asterisk }
                                医疗机构(参与单位):
                            </div>
                        :
                            <div className="item-left">医疗机构(参与单位):</div>
                    }
                    {
                        !isEdit ?
                            <div className="item-right">
                                <div style={{ marginBottom: 10 }}>
                                    <SearchInput
                                        data={joinList}
                                        style={{width: 200}}
                                        value={joinValue}
                                        keyword="hospitalName"
                                        saveData={this.saveJoinData}
                                        saveValue={this.saveJoinValue}
                                        options={this.parseJoinData()}
                                        url={API_URL.invStartUp.queryHospitalListByInve}
                                    />
                                    <Icon
                                        type="plus-circle-o"
                                        onClick={this.handleAdd}
                                        style={{marginLeft: 10, fontSize: 20, verticalAlign: 'middle', cursor: 'pointer'}}
                                    />
                                </div>
                                { this.getContentList('join') }
                            </div>
                        :
                            <div className="item-right">
                                { joinHeredityHospitalName }
                            </div>
                    }
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}申报进展:</div>
                    <div className="item-right">
                        <Select
                            placeholder="请选择"
                            style={{width: 200}}
                            value={declareProgressId}
                            onFocus={this.getHeredityDeclareList}
                            onChange={value => this.handleChange(value, 'declareProgressId')}
                            allowClear={true}
                        >
                            {heredityDeclareOptions}
                        </Select>
                    </div>
                </li>
                {
                    (heredityDeclareType == 'PERSON_HEREDITY_RESEARCH' || 
                    (heredityDeclareType == 'REGISTER_LISTED_OPTIMIZE' && (registerListedOptimizeDeclareType == 'FIRST_DECLARE' || registerListedOptimizeDeclareType == 'SUPPLEMENT_DECLARE'))) &&
                    <div>
                        <li className="modal-item">
                            <div className="item-left">
                                { declareProgressId == '8' && asterisk }
                                批文号码:
                            </div>
                            {
                                declareProgressId == '8' &&
                                <div className="item-right">
                                    <Input
                                        maxLength='200'
                                        placeholder="请输入"
                                        style={{width: 200}}
                                        value={approvalNumber}
                                        onChange={e => this.handleChange(e.target.value, 'approvalNumber')}
                                    />
                                </div>
                            }
                        </li>
                        <li className="modal-item">
                            <div className="item-left">
                                { declareProgressId == '8' && asterisk }
                                批文有效期:
                            </div>
                            {
                                declareProgressId == '8' &&
                                <div className="item-right">
                                    <DatePicker
                                        style={{width: 200}}
                                        format={dateFormat}
                                        placeholder="请选择"
                                        value={showApprovalValidityDate}
                                        onChange={(date, dateString) => this.handleChange(dateString, "approvalValidityDate")}
                                    />
                                </div>
                            }
                        </li>
                    </div>
                }
                {   
                    (heredityDeclareType == 'REGISTER_LISTED_OPTIMIZE' && registerListedOptimizeDeclareType == 'JOIN_DEPARTMENT_RECORD') &&
                    <div>
                        <li className="modal-item">
                            <div className="item-left">邮件备案或材料寄出日期:</div>
                            <div className="item-right">
                                {
                                    (declareProgressId == '11' || declareProgressId == '12') &&
                                    <DatePicker
                                        style={{width: 200}}
                                        format={dateFormat}
                                        placeholder="请选择"
                                        value={showMailRecordDate}
                                        onChange={(date, dateString) => this.handleChange(dateString, "mailRecordDate")}
                                    />
                                }
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">
                                { declareProgressId == '12' && asterisk }
                                遗传办回复日期:
                            </div>
                            <div className="item-right">
                                {
                                    declareProgressId == '12' &&
                                    <DatePicker
                                        style={{width: 200}}
                                        format={dateFormat}
                                        placeholder="请选择"
                                        value={showHeredityReplyDate}
                                        onChange={(date, dateString) => this.handleChange(dateString, "heredityReplyDate")}
                                    />
                                }
                            </div>
                        </li>
                    </div>
                }
                <li className="modal-item">
                    <div className="item-left"> 备注: </div>
                    <div className="item-right">
                        <TextArea
                            maxLength='200'
                            value={remark}
                            placeholder="请输入备注"
                            style={{width: 200, height: 80}}
                            onChange={e => this.handleChange(e.target.value, 'remark')}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render () {
        const { visible, confirmLoading, isEdit } = this.state;
        return (
            <div>
                <Modal
                    title={!isEdit ? "添加遗传办记录" : "修改遗传办记录"}
                    visible={visible}
                    onCancel={this.close}
                    onOk={this.confirm}
                    className="preview-modal"
                    wrapClassName="vertical-center-modal"
                    confirmLoading={confirmLoading}
                    width="540px"
                >
                    <div className="modal-content heredity">
                        { this.getHeredityRecord() }
                    </div>
                </Modal>
                <AddTeamLeaderUnit ref={el => this.teamLeaderUnitRef = el} onChange={this.handleChange} />
                <AddCooperationUnit ref={el => this.cooperationUnitRef = el} onChange={this.handleChange} />
            </div>
        );
    }
}

export default HeredityView;


// WEBPACK FOOTER //
// ./src/components/invStartUp/heredity/HeredityView.js